module.exports = __webpack_public_path__ + "static/media/eSports.45d44480.svg";